export enum RMAService {
  Tyre = 'TyreService',
  Battery = 'BatteryService'
}
